var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { INDRAExtraSidebar } from '@ibe.components/shared/sidebar-views/ancillaries/extra-sidebar.indra.abstract';
import { EXTRAS_ANCILLARY_MEAL, PAX_TYPE_ADULT_CODE, PAX_TYPE_CHILD_CODE, PAX_TYPE_INFANT_CODE, SSR_CODE_MEAL_BABY, SSR_CODE_MEAL_CHILD, TRANSLATION_ANCILLARIES_TYPE, TRANSLATION_ANCILLARY_DETAILED, TRANSLATION_ANCILLARY_LABEL, TRANSLATION_ANCILLARY_TEXTS, TRANSLATION_ANCILLARY_TITLE, TRANSLATION_SPECIAL_MEALS, SSR_CODE_MEAL_SEAFOOD_1, ANCILLARY_PRODUCT_GROUP_CODE_MEAL, TRANSLATION_ANCILLARY_ARIA_LABEL, SSR_CODE_MEAL_FISH, SSR_CODE_MEAL_PASTA, SSR_CODE_MEAL_POULTRY, SSR_CODE_MEAL_MEAT, SSR_CODE_FIREARMS, SSR_CODE_SPORTS_SPORTING_EQUIPMENT, PAX_TYPE_YOUNG_ADULT_CODE, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP, TRANSLATION_ALT, SSR_CODE_MEAL_SKIP, TRANSLATION_ANCILLARY_PREORDER } from '@ibe.config';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAMybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { of, Subject } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import * as _ from 'lodash';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { DomSanitizer } from '@angular/platform-browser';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { getCurrencySymbol } from '@angular/common';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
var INDRASpecialMealsComponent = /** @class */ (function (_super) {
    __extends(INDRASpecialMealsComponent, _super);
    function INDRASpecialMealsComponent(sidebarService, route, router, bookingService, mybService, bfmService, fb, ibeAdminService, ancillariesSelectionSrv, ancillariesService, ancillariesShoppingCartSrv, dateService, googleAnalytics, storageService, store, ibeAdminConfigService, currencyPipe, paymentInfoService, domSanitizer, currencyService) {
        var _this = _super.call(this, sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_MEAL, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService) || this;
        _this.bfmService = bfmService;
        _this.fb = fb;
        _this.ibeAdminService = ibeAdminService;
        _this.ancillariesService = ancillariesService;
        _this.ibeAdminConfigService = ibeAdminConfigService;
        _this.currencyPipe = currencyPipe;
        _this.paymentInfoService = paymentInfoService;
        _this.domSanitizer = domSanitizer;
        _this.currencyService = currencyService;
        _this.INF_CODE = PAX_TYPE_INFANT_CODE;
        _this.notificationDuration = 2.5; // in seconds
        _this.$preOrder = _this.store.select(fromStore.getPreOrderEligibility);
        _this.isAlive = true;
        _this.translationAncillaryDetailedKey = TRANSLATION_ANCILLARY_DETAILED;
        _this.stops = [];
        _this.preOrderMealsCollectionLabel = {
            text: '-------- PRE ORDER --------',
            value: '',
            isLabel: true
        };
        _this.specialMealsCollectionLabel = {
            text: '-------- SPECIAL MEAL --------',
            value: '',
            isLabel: true
        };
        _this.specialMealsCollection = [
            {
                name: 'Fish meal',
                value: 'Fish meal',
                price: 0,
                codes: [SSR_CODE_MEAL_FISH],
                img: '/assets/images/ancillaries/meals/cherne.png'
            },
            {
                name: 'Pork roast with roasted potatoes',
                value: 'pork-roast-with-roasted-potatoes',
                price: 0,
                codes: [],
                img: '/assets/images/ancillaries/meals/vitela.png'
            },
            {
                name: 'Poultry meal',
                value: 'Poultry meal',
                price: 0,
                codes: [SSR_CODE_MEAL_POULTRY],
                img: '/assets/images/ancillaries/meals/pato.png'
            },
            {
                name: 'Seafood meal',
                value: 'Seafood meal',
                price: 0,
                codes: [SSR_CODE_MEAL_SEAFOOD_1],
                img: '/assets/images/ancillaries/meals/Caril-de-Peixe-com-erva-principe-batata-doce-e-maca.jpg'
            },
            {
                name: 'Pasta meal',
                value: 'Pasta meal',
                price: 0,
                codes: [SSR_CODE_MEAL_PASTA],
                img: '/assets/images/ancillaries/meals/Panzerotti-com-cogumelos-porcini.jpg'
            },
            {
                name: 'Meat meal',
                value: 'Meat meal',
                price: 0,
                codes: [SSR_CODE_MEAL_MEAT],
                img: '/assets/images/ancillaries/meals/Terrina-de-Novilho-e-Cenoura.jpg'
            }
        ];
        _this.paxPurchaseFeatures = [];
        _this.allSubscriptions = [];
        _this.milesNeeded = 0;
        _this.addedAncillary = [];
        _this.isModificationDisallowed = false;
        _this.allSegmentAncList = [];
        _this.skipLastSegment = new Subject();
        _this.hideSegmentTabs = false;
        _this.flightWithMealAncSegments = [];
        _this.skipMealAncillaries = [];
        _this.mealSkipSSR = SSR_CODE_MEAL_SKIP;
        _this.mealSkipAdded = false;
        _this.formsPerPassenger = [];
        // get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
        var isBookingCreatedParam = _this.route.snapshot.paramMap.get('isBookingCreated');
        if (isBookingCreatedParam === 'true') {
            _this.isModificationDisallowed = true;
        }
        _this.$preOrder
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.preOrder = value.split(',');
            }
        });
        return _this;
    }
    INDRASpecialMealsComponent.prototype.createFormGroup = function () {
        return this.fb.group({
            specialMealsAdd: null,
            noMealBox: false
        });
    };
    INDRASpecialMealsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.paramSubscription = this.route.paramMap.pipe(switchMap(function (params) {
            return of(params.get('flight'));
        })).subscribe(function (d) {
            _this.setParams();
        });
        this.allSubscriptions.push(this.paramSubscription);
        this.INDRA_getAddedAncillaries();
        var _loop_1 = function (i) {
            var feature = this_1.INDRA_getAddedAncillariesForPassengerSegment(this_1.passengers[i].idPax, this_1.flightStop.idInfoSegment);
            if (feature.length != 0) {
                var shoppingCartItems = this_1.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
                this_1.milesNeeded = this_1.milesNeeded + feature[0].points;
                this_1.payWithMiles = shoppingCartItems.itemsAdded.find(function (item) { return item.type == feature[0].type; }).payWithMiles;
                // If ZZML feature is selected, clear select box and set skip meal checkbox to true
                if (feature.some(function (feature) { return feature.code === SSR_CODE_MEAL_SKIP; })) {
                    this_1.formsPerPassenger[i].get('specialMealsAdd').setValue(null);
                    this_1.formsPerPassenger[i].get('specialMealsAdd').disable();
                    this_1.formsPerPassenger[i].get('noMealBox').setValue(true);
                }
            }
        };
        var this_1 = this;
        for (var i in this.passengers) {
            _loop_1(i);
        }
        this.INDRA_getAddOnForPassengerSegmentByPaxType();
    };
    INDRASpecialMealsComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
            sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    INDRASpecialMealsComponent.prototype.setParams = function () {
        var _this = this;
        this.isAlive = true;
        this.formsPerPassenger = [];
        this.flightCardId = this.route.snapshot.paramMap.get('flight');
        this.flight = this.bookingService.INDRA_getBookedFlight(this.flightCardId);
        this.passengers = this.bookingService.INDRA_getPaxInfo();
        var purchasedAncillaryWithSegmentInfo = this.bookingService.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo(ANCILLARY_PRODUCT_GROUP_CODE_MEAL, this.flight.idFlight.toString(), this.flightCardId);
        this.passengers.forEach(function (passenger) {
            var _a, _b;
            _this.formsPerPassenger.push(_this.createFormGroup());
            var purchasedIndex = purchasedAncillaryWithSegmentInfo.findIndex(function (object) { return object[passenger.idPax]; });
            if (purchasedIndex === -1) {
                _this.paxPurchaseFeatures.push((_a = {},
                    _a[passenger.idPax] = [],
                    _a));
            }
            else {
                var paxpurchasedAncillaries = purchasedAncillaryWithSegmentInfo[purchasedIndex];
                _this.paxPurchaseFeatures.push((_b = {},
                    _b[passenger.idPax] = _this.INDRA_constructAncillaryListForPurchased(paxpurchasedAncillaries[passenger.idPax]),
                    _b));
            }
        });
        var segmentIndex = 0;
        this.stops = [];
        this.INDRA_selectedStop(0, true);
        this.INDRA_checkMealAvailabilityPerSegment(); // get this.allSegmentAncList
        this.flightWithMealAncSegments = _.cloneDeep(this.flight);
        var segmentsWithMealsCount = 0;
        this.flight.listSegment.forEach(function (segment, index) {
            // check if segment has meal ancillary
            // disable button of segment with no meals
            var segmentAnc = _this.allSegmentAncList.filter(function (seg) { return seg.segmentId == segment.idInfoSegment; });
            // if atleast one pax type has ancillary meal do not disable
            var hasAncillaries = segmentAnc.some(function (seg) { return seg.ancillaries && seg.ancillaries.length > 0; });
            if (!hasAncillaries) {
                _this.flightWithMealAncSegments['listSegment'].splice(index, 1);
            }
            else {
                segmentsWithMealsCount = segmentsWithMealsCount + 1;
            }
            // fills input for segmented control radio
            _this.stops.push({
                label: segment.departureAirport + '-' + segment.arrivalAirport,
                value: segmentIndex,
                disableButton: !hasAncillaries,
                tooltip: !hasAncillaries ? _this.INDRA_getTranslation(TRANSLATION_ANCILLARY_DETAILED + 'specialMealsNotAvailable') : null
            });
            segmentIndex++;
        });
        if (segmentsWithMealsCount <= 1) {
            this.hideSegmentTabs = true;
        }
        _super.prototype.ngOnInit.call(this);
        setTimeout(function () {
            _this.passengers.forEach(function (pax, i) {
                var added = _this.INDRA_getAddedAncillariesForPassengerSegment(i + 1, _this.flightStop.idInfoSegment);
                // Set added ancillaries for each passenger
                if (added.length && added[0].code !== SSR_CODE_MEAL_SKIP) {
                    _this.formsPerPassenger[i].patchValue({
                        specialMealsAdd: added[0]
                    });
                }
            });
        }, 10);
    };
    INDRASpecialMealsComponent.prototype.checkAssociatedInfant = function (idPax) {
        return this.passengers.find(function (data) { return data.infToAdt == idPax; });
    };
    INDRASpecialMealsComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_chosenValue = function (targetPassengerIndex) {
        var _this = this;
        var form = this.formsPerPassenger[targetPassengerIndex];
        var selectedValue = form.get('specialMealsAdd').value;
        if (selectedValue) {
            var value = selectedValue;
            if (value.segmentId === this.flightStop.idInfoSegment) {
                return value;
            }
        }
        else if (this.skipMealAncillaries) {
            var skipValue = form.get('noMealBox').value;
            if (skipValue) {
                var value = skipValue;
                var skipMealAncillary = this.skipMealAncillaries.find(function (option) {
                    return _this.passengers[targetPassengerIndex].idPax === option.paxId && _this.flightStop.idInfoSegment === option.segmentId;
                });
                return skipMealAncillary;
            }
        }
        return null;
    };
    INDRASpecialMealsComponent.prototype.INDRA_chosenValueFromCollection = function (targetPassengerIndex) {
        var idPax = this.passengers[targetPassengerIndex].idPax;
        var chosenVal = this.INDRA_chosenValue(targetPassengerIndex);
        var ancillaries = this.INDRA_getAddOnForPassengerSegment(idPax, this.flightStop.idInfoSegment);
        if (chosenVal) {
            var returnObj = ancillaries.find(function (val) { return JSON.stringify(Object.entries(val).sort()) == JSON.stringify(Object.entries(chosenVal).sort()); });
            return returnObj ? returnObj : chosenVal;
        }
    };
    INDRASpecialMealsComponent.prototype.copyToOtherFlights = function () {
        var _this = this;
        var ancillaryAdded = false;
        // purge all the previously selected for other segments.
        this.purgeAncillariesForOtherSegments();
        // gathers the segment Ids except segment id of the selected stop
        var otherSegmentIDs = this.INDRA_getOtherSegmentIDs();
        this.passengers.forEach(function (pax) {
            // gathers the ancillary that will copied to other segments
            var paxAddedAncillaries = _this.INDRA_getAddedAncillariesForPassengerSegment(pax.idPax, _this.flightStop.idInfoSegment);
            paxAddedAncillaries.forEach(function (paxAddedAncillary) {
                otherSegmentIDs.forEach(function (segmentId) {
                    /* this will ensure that same ancillary code and price is being offered on the other segment.
                        otherwise, it should not be added.*/
                    var newPaxAddedAncillary = _this.bookingService.INDRA_getAddOnAncillariesForPassengerSegment(EXTRAS_ANCILLARY_MEAL, _this.flightCardId, _this.flight.idFlight, segmentId, paxAddedAncillary.code, pax.idPax);
                    if (newPaxAddedAncillary.code) {
                        // adding the copied ancillary for the other flight.
                        _this.INDRA_handleAddAncillary(newPaxAddedAncillary);
                        ancillaryAdded = true;
                    }
                });
            });
        });
        if (ancillaryAdded) {
            this.showNotification('addMoreSidebars.specialMeals.texts.appliedSuccessfullyToOtherFlights');
        }
    };
    INDRASpecialMealsComponent.prototype.purgeAncillariesForOtherSegments = function () {
        var _this = this;
        var otherSegmentIDs = this.INDRA_getOtherSegmentIDs();
        this.passengers.forEach(function (pax) {
            otherSegmentIDs.forEach(function (segmentId) {
                var paxAddedAncillaries = _this.INDRA_getAddedAncillariesForPassengerSegment(pax.idPax, segmentId);
                paxAddedAncillaries.forEach(function (paxAddedAncillary) {
                    _this.INDRA_handleRemoveSegmentAncillary(paxAddedAncillary, segmentId);
                });
            });
        });
    };
    INDRASpecialMealsComponent.prototype.showNotification = function (message) {
        this.notificationMessage = message;
        this.notificationShowing = true;
        window.setTimeout(this.dismissNotification.bind(this), this.notificationDuration * 1000);
        this.lastActiveElement = document.activeElement;
        this.$notification.nativeElement.focus();
    };
    INDRASpecialMealsComponent.prototype.dismissNotification = function () {
        this.notificationShowing = false;
        this.lastActiveElement.focus();
    };
    INDRASpecialMealsComponent.prototype.INDRA_openSlideshow = function (passenger) {
    };
    INDRASpecialMealsComponent.prototype.INDRA_flowActionsClasses = function () {
        return { 'flow_actions--wide': !this.INDRA_hasNextFlight() };
    };
    INDRASpecialMealsComponent.prototype.INDRA_hasNextFlight = function () {
        // TODO implement this
        return this.flight.listSegment.length > 1 /* || this.bookingService.INDRA_hasNextFlight(this.flightIdentifier) */;
        // return this.booking.flights.length > 1 && this.booking.flights.indexOf(this.flight) < this.booking.flights.length - 1;
    };
    INDRASpecialMealsComponent.prototype.INDRA_hasPreviousFlight = function () {
        // TODO implement this
        return this.flight.listSegment.length > 1 /* && this.booking.flights.indexOf(this.flight) > 0 */;
    };
    INDRASpecialMealsComponent.prototype.INDRA_getTitle = function () {
        return this.INDRA_getTranslation("" + (TRANSLATION_ANCILLARIES_TYPE + TRANSLATION_ALT + EXTRAS_ANCILLARY_MEAL));
    };
    INDRASpecialMealsComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRASpecialMealsComponent.prototype.INDRA_printAddButtonLabel = function (idPax) {
        var features = this.INDRA_getAddOnForPassengerSegment(idPax, this.flightStop.idInfoSegment);
        var feature = features[0];
        return this.INDRA_getTranslation("" + (this.translationAncillaryDetailedKey + feature.code))
            + ' ('
            + this.currencyPipe.transform(feature.price)
            + ')';
    };
    INDRASpecialMealsComponent.prototype.INDRA_printAddedButtonLabel = function (idPax) {
        var features = this.INDRA_getAddOnForPassengerSegment(idPax, this.flightStop.idInfoSegment);
        var feature = features[0];
        return this.INDRA_getTranslation("" + (this.translationAncillaryDetailedKey + feature.code));
    };
    INDRASpecialMealsComponent.prototype.INDRA_printRemoveButtonLabel = function (idPax) {
        var features = this.INDRA_getAddOnForPassengerSegment(idPax, this.flightStop.idInfoSegment);
        var feature = features[0];
        return this.currencyPipe.transform(feature.price) + this.INDRA_getCurrencySymbol(feature.currency);
    };
    INDRASpecialMealsComponent.prototype.INDRA_getAddOnForPassengerSegmentByPaxType = function () {
        var _this = this;
        this.optionList = [];
        if (this.passengers.length > 0) {
            this.passengers.forEach(function (passenger) {
                var ancilliaries = _this.INDRA_getAddOnForPassengerSegment(passenger.idPax, _this.flightStop.idInfoSegment);
                var hasINF = _this.checkforInfToAdt(passenger.idPax);
                if (ancilliaries && ancilliaries.length > 0) {
                    ancilliaries.filter(function (option) {
                        if (option.code === SSR_CODE_MEAL_SKIP) {
                            _this.skipMealAncillaries.push(option);
                        }
                    });
                    switch (passenger.typePax) {
                        case PAX_TYPE_ADULT_CODE:
                            if (hasINF) {
                                _this.optionList.push(_this.INDRA_mapAncillaryOptions(ancilliaries.filter(function (meal) { return meal.code != SSR_CODE_MEAL_CHILD; }), _this.translationAncillaryDetailedKey));
                                return;
                            }
                            _this.optionList.push(_this.INDRA_mapAncillaryOptions(ancilliaries.filter(function (meal) { return meal.code != SSR_CODE_MEAL_BABY && meal.code != SSR_CODE_MEAL_CHILD; }), _this.translationAncillaryDetailedKey));
                            return;
                        case PAX_TYPE_YOUNG_ADULT_CODE:
                            _this.optionList.push(_this.INDRA_mapAncillaryOptions(ancilliaries.filter(function (meal) { return meal.code != SSR_CODE_MEAL_BABY && meal.code != SSR_CODE_MEAL_CHILD; }), _this.translationAncillaryDetailedKey));
                            return;
                        case PAX_TYPE_CHILD_CODE:
                            var childAncilliaries = ancilliaries.filter(function (meal) { return meal.code == SSR_CODE_MEAL_CHILD; });
                            childAncilliaries = childAncilliaries.concat(ancilliaries.filter(function (meal) { return meal.code != SSR_CODE_MEAL_BABY && meal.code != SSR_CODE_MEAL_CHILD; }));
                            _this.optionList.push(_this.INDRA_mapAncillaryOptions(childAncilliaries, _this.translationAncillaryDetailedKey));
                            return;
                        case PAX_TYPE_INFANT_CODE:
                            _this.optionList.push(_this.INDRA_mapAncillaryOptions(ancilliaries.filter(function (meal) { return meal.code == SSR_CODE_MEAL_BABY; }), _this.translationAncillaryDetailedKey));
                            return;
                        default:
                            break;
                    }
                }
            });
        }
    };
    INDRASpecialMealsComponent.prototype.checkforInfToAdt = function (idPax) {
        return this.passengers.find(function (data) { return data.infToAdt == idPax; });
    };
    INDRASpecialMealsComponent.prototype.INDRA_getTextTranslation = function (lastKey) {
        var key = TRANSLATION_SPECIAL_MEALS + TRANSLATION_ANCILLARY_TEXTS + lastKey;
        return key;
    };
    INDRASpecialMealsComponent.prototype.INDRA_getTitleTranslation = function (lastKey) {
        var key = TRANSLATION_SPECIAL_MEALS + TRANSLATION_ANCILLARY_TITLE + lastKey;
        return key;
    };
    INDRASpecialMealsComponent.prototype.INDRA_getLabelTranslation = function (lastKey) {
        var key = TRANSLATION_SPECIAL_MEALS + TRANSLATION_ANCILLARY_LABEL + lastKey;
        return key;
    };
    INDRASpecialMealsComponent.prototype.INDRA_resetPassengerForm = function (targetPassengerIndex) {
        var form = this.formsPerPassenger[targetPassengerIndex];
        form.get('specialMealsAdd').setValue(null);
        form.updateValueAndValidity();
    };
    INDRASpecialMealsComponent.prototype.INDRA_selectedStop = function (value, isFlightNavigation) {
        if (isFlightNavigation === void 0) { isFlightNavigation = false; }
        this.INDRA_clearForms();
        var isNavigatingBack = false;
        if (this.previousSegmentId != 0 && this.previousSegmentId > value) {
            isNavigatingBack = true;
        }
        this.selectedStop = value;
        this.flightStop = this.flight.listSegment[this.selectedStop];
        if (isFlightNavigation) {
            // navigate to other flight segment
            if (!this.paxAddOnFeatures[this.flightCardId]) {
                this.optionList = [];
                this.paxAddOnFeatures[this.flightCardId] = this.bookingService.INDRA_getAddOnAncillaries(this.ancillariesType, this.flight.idFlight.toString(), this.flightCardId)
                    .filter(function (item) { return item.code != SSR_CODE_FIREARMS && item.code != SSR_CODE_SPORTS_SPORTING_EQUIPMENT; });
            }
        }
        this.INDRA_getAddOnForPassengerSegmentByPaxType();
        var hasMealAnc = this.INDRA_avaibleForFlight();
        this.presetValues();
        if (!hasMealAnc) {
            var segmentTotal = this.flight.listSegment.length;
            if (this.selectedStop == (segmentTotal - 1).toString()) { // this handles next button when last segment
                this.skipLastSegment.next('next');
                this.selectedStop = '0';
            }
            else if (isNavigatingBack && this.selectedStop == '0') { // this handles previous button when last segment
                this.skipLastSegment.next('previous');
                this.selectedStop = '0';
            }
            else if (isNavigatingBack && this.selectedStop != '0') {
                // this handles back button that skips but is not at the first segment
                this.selectedStop = (+value - 1).toString();
            }
            else {
                this.selectedStop = value + 1;
                this.INDRA_selectedStop(this.selectedStop, true);
            }
        }
        this.previousSegmentId = this.selectedStop;
        if (this.preOrder && this.preOrder.includes('' + this.flightStop.idInfoSegment)) {
            this.isServiceLoading = true;
            this.INDRA_addToPreOrderMap(this.flightStop);
        }
        else {
            this.INDRA_setAddedMeals();
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_selectSkipMeal = function (passenger_index, idPax) {
        this.formsPerPassenger[passenger_index].controls['specialMealsAdd'].setValue(null);
        if (this.formsPerPassenger[passenger_index].controls['noMealBox'].value) {
            this.formsPerPassenger[passenger_index].controls['specialMealsAdd'].disable();
        }
        else {
            this.formsPerPassenger[passenger_index].controls['specialMealsAdd'].enable();
        }
        this.INDRA_specialMealsAdd(passenger_index, idPax);
    };
    INDRASpecialMealsComponent.prototype.INDRA_avaibleForFlight = function () {
        var stopHasMealCatalog = false;
        if (this.flightStop) {
            for (var i = 0; i < this.passengers.length; i++) {
                var pax = this.passengers[i];
                var addOnAncillaryList = this.INDRA_getAddOnForPassengerSegment(pax.idPax, this.flightStop.idInfoSegment);
                if (addOnAncillaryList && addOnAncillaryList.length > 0) {
                    stopHasMealCatalog = true;
                    break;
                }
            }
        }
        return stopHasMealCatalog;
    };
    INDRASpecialMealsComponent.prototype.presetValues = function () {
        for (var i = 0; i < this.passengers.length; i++) {
            var pax = this.passengers[i];
            this.formsPerPassenger[i].controls['specialMealsAdd'].setValue(null);
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_getLocation = function (code) {
        return this.bookingService.INDRA_getLocation(code).city;
    };
    INDRASpecialMealsComponent.prototype.INDRA_handleNext = function () {
        if (this.INDRA_hasNextFlight()) {
            var lastStop = this.flight.listSegment.length - 1;
            if (Number(this.selectedStop) >= lastStop) {
                // selected stop is last stop of the flight card
                /* if (this.bookingService.INDRA_hasNextFlight(this.flightIdentifier)) {
                    const nextFlightCardId = Number(this.flightIdentifier) + 1;
                    this.router.navigate([{ outlets: { sidebar: ['ancillaries--special-meals', { flight: nextFlightCardId }] } }]);
                } else {
                    super.INDRA_handleClose();
                } */
                this.INDRA_handleDone();
            }
            else {
                this.INDRA_selectedStop(this.selectedStop + 1, true);
            }
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_handlePrevious = function () {
        // TODO implement this
        /*
        const flights = JSON.parse(JSON.stringify(this.booking.flights));
        const idx = flights.sort((a, b) => a.departure.time - b.departure.time).findIndex(cur => cur.id == this.flightIdentifier);
        const nextFlight = flights[idx - 1] || false;
        const nextFlightId = nextFlight ? nextFlight.id : false;

        const currentIndexStop = this.stops.findIndex(cur => cur.value == this.selectedStop);
        const lastStop = this.flight.listSegment.length - 1;
        if (Number(this.selectedStop) == lastStop) {
            if (nextFlightId) {
                this.selectedStop = nextFlight.stops_labels[0].id;
                this.router.navigate([{ outlets: { sidebar: ['ancillaries--special-meals', { flight: nextFlightId }] } }]);
            } else {
                super.TAP_handleClose();
            }
        } else {
            this.TAP_selectedStop(this.stops[currentIndexStop + 1].value);
        }
        */
    };
    /*
    *	Gather the segment Ids of the flight except from the current active stop.
    * 	This will be utilized by apply to others flights functionality
    */
    INDRASpecialMealsComponent.prototype.INDRA_getOtherSegmentIDs = function () {
        var _this = this;
        var segments = [];
        this.flight.listSegment.forEach(function (segment) {
            if (segment.idInfoSegment !== _this.flightStop.idInfoSegment) {
                segments.push(segment.idInfoSegment);
            }
        });
        return segments;
    };
    INDRASpecialMealsComponent.prototype.INDRA_checkMealImage = function (meal) {
        if (meal) {
            var selectedMeal = this.specialMealsCollection.find(function (data) { return data.codes.indexOf(meal.code) >= 0; });
            return selectedMeal && selectedMeal.img ? selectedMeal : null;
        }
        else {
            return null;
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_isPresentOnFareInformation = function () {
        return this.bookingService.INDRA_isPresentOnFareInformation(ANCILLARY_PRODUCT_GROUP_CODE_MEAL, this.flightCardId);
    };
    INDRASpecialMealsComponent.prototype.INDRA_getPurchasedAncillaryForPassenger = function (idPax) {
        var returnValue = [];
        var index = this.paxPurchaseFeatures.findIndex(function (item) { return Object.keys(item)[0] === idPax.toString(); });
        if (this.paxPurchaseFeatures) {
            var paxAncillary = this.paxPurchaseFeatures[index];
            returnValue = paxAncillary[idPax];
            return returnValue;
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_constructAncillaryListForPurchased = function (list) {
        var returnValue = [];
        list.forEach(function (segment) {
            returnValue.push({
                ancillaryDetail: '',
                segmentId: segment.segmentId,
                unconfirmed: segment.ancillaryList[0].unconfirmed
            });
        });
        return returnValue;
    };
    INDRASpecialMealsComponent.prototype.INDRA_getAriaLabelTranslation = function (lastKey) {
        var key = TRANSLATION_SPECIAL_MEALS + TRANSLATION_ANCILLARY_ARIA_LABEL + lastKey;
        return key;
    };
    INDRASpecialMealsComponent.prototype.INDRA_addAncillary = function (passenger_index) {
        var ancillaryDetails = this.INDRA_chosenValueFromCollection(passenger_index);
        if (ancillaryDetails) {
            this.INDRA_handleAddAncillary(ancillaryDetails);
            this.addedAncillary.push(ancillaryDetails);
            this.milesNeeded = this.milesNeeded + ancillaryDetails.points;
            this.recentlyAddedAncillary = Object.assign({}, ancillaryDetails);
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_removeAncillary = function (ancillary, idInfoSegment) {
        this.addedAncillary = this.addedAncillary.filter(function (item) { return item.paxId != ancillary.paxId; });
        this.INDRA_handleRemoveSegmentAncillary(ancillary, idInfoSegment);
        this.milesNeeded = this.milesNeeded - ancillary.points;
        this.recentlyAddedAncillary = null;
    };
    INDRASpecialMealsComponent.prototype.INDRA_showPayWithMilesOption = function () {
        if (this.INDRA_hasAddedAncillaries()) {
            // tslint:disable-next-line:radix
            if (parseInt(this.recentlyAddedAncillary) > 0) {
                return true;
            }
        }
        else {
            return true;
        }
        return false;
    };
    INDRASpecialMealsComponent.prototype.INDRA_checkMealAvailabilityPerSegment = function () {
        var _this = this;
        var otherSegmentIDs = this.INDRA_getOtherSegmentIDs();
        this.allSegmentAncList = [];
        this.passengers.forEach(function (pax) {
            var ancilliaries = _this.INDRA_getAddOnForPassengerSegment(pax.idPax, _this.flightStop.idInfoSegment);
            _this.allSegmentAncList.push({
                segmentId: _this.flightStop.idInfoSegment.toString(),
                ancillaries: ancilliaries
            });
            otherSegmentIDs.forEach(function (segmentId) {
                var id = segmentId.toString();
                var otherSegmentAncillaries = _this.INDRA_getAddOnForPassengerSegment(pax.idPax, id);
                _this.allSegmentAncList.push({
                    segmentId: id,
                    ancillaries: otherSegmentAncillaries
                });
            });
        });
    };
    INDRASpecialMealsComponent.prototype.INDRA_hasMealAdded = function (paxId) {
        var hasMealAdded = this.addedAncillary.find(function (data) { return data.paxId == paxId; });
        if (hasMealAdded) {
            return true;
        }
        return false;
    };
    INDRASpecialMealsComponent.prototype.INDRA_checkAncPerSegment = function () {
        return !this.hideSegmentTabs;
    };
    INDRASpecialMealsComponent.prototype.INDRA_clearForms = function () {
        var _this = this;
        this.passengers.forEach(function (passenger, index) {
            _this.formsPerPassenger[index].controls['specialMealsAdd'].enable();
            _this.formsPerPassenger[index].controls['noMealBox'].enable();
            _this.formsPerPassenger[index].controls['noMealBox'].setValue(null);
        });
    };
    INDRASpecialMealsComponent.prototype.INDRA_getAddedAncillaries = function () {
        var _this = this;
        for (var i in this.passengers) {
            var paxFeatures = this.INDRA_getAddedAncillariesForPassenger(this.passengers[i].idPax);
            paxFeatures.forEach(function (feature) {
                _this.addedAncillary.push(feature);
            });
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_skipMealAvailable = function (paxId) {
        var _this = this;
        var availableForPaxSegment = false;
        if (this.skipMealAncillaries && this.skipMealAncillaries.length) {
            this.skipMealAncillaries.forEach(function (anc) {
                if (anc.paxId === paxId && anc.flightId === _this.flight.idFlight && anc.segmentId === _this.flightStop.idInfoSegment) {
                    availableForPaxSegment = true;
                }
            });
        }
        return availableForPaxSegment;
    };
    INDRASpecialMealsComponent.prototype.INDRA_setAddedMeals = function () {
        var _this = this;
        this.passengers.forEach(function (passenger, index) {
            var paxAddedAncillaries = _this.INDRA_getAddedAncillariesForPassengerSegment(passenger.idPax, _this.flightStop.idInfoSegment);
            // Get all added and selected ancillaries
            var allAddedAncillaries = _this.addedAncillary.concat(paxAddedAncillaries);
            // Populate form with added ancillaries
            if (allAddedAncillaries.length) {
                allAddedAncillaries.forEach(function (anc) {
                    if (anc.paxId === passenger.idPax && anc.flightId === _this.flight.idFlight && anc.segmentId === _this.flightStop.idInfoSegment) {
                        if (anc.code === _this.mealSkipSSR) {
                            _this.formsPerPassenger[index].get('specialMealsAdd').setValue(null);
                            _this.formsPerPassenger[index].controls['specialMealsAdd'].disable();
                            _this.formsPerPassenger[index].controls['noMealBox'].enable();
                            _this.formsPerPassenger[index].controls['noMealBox'].setValue(true);
                        }
                        else {
                            var selectedOption_1 = _this.optionList[index].find(function (option) { return option.value.code === anc.code; });
                            setTimeout(function () {
                                _this.formsPerPassenger[index].controls['noMealBox'].enable();
                                _this.formsPerPassenger[index].controls['noMealBox'].setValue(null);
                                _this.formsPerPassenger[index].controls['specialMealsAdd'].enable();
                                _this.formsPerPassenger[index].controls['specialMealsAdd'].setValue(selectedOption_1.value);
                            });
                        }
                    }
                });
            }
        });
    };
    INDRASpecialMealsComponent.prototype.INDRA_specialMealsAdd = function (targetPassengerIndex, idPax) {
        var _this = this;
        // this will remove previously added ancillary for the same passenger on the same segment
        if (this.addedAncillary.length) {
            this.addedAncillary.forEach(function (anc) {
                if (anc.length) {
                    anc.forEach(function (el) {
                        if (_this.flightStop.idInfoSegment === el.segmentId && el.paxId === idPax) {
                            _this.INDRA_removeAncillary(el, _this.flightStop.idInfoSegment);
                        }
                    });
                }
                else {
                    if (_this.flightStop.idInfoSegment === anc.segmentId && anc.paxId === idPax) {
                        _this.INDRA_removeAncillary(anc, _this.flightStop.idInfoSegment);
                    }
                }
            });
        }
        this.INDRA_addAncillary(targetPassengerIndex); // this is the add button that is removed
    };
    INDRASpecialMealsComponent.prototype.INDRA_compareSelect = function (formValue, optionValue) {
        if (formValue && optionValue) {
            if (formValue.code == optionValue.code) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_displaySelectMeal = function (meal) {
        if (meal.value.code === SSR_CODE_MEAL_SKIP) {
            return false;
        }
        else {
            return true;
        }
    };
    INDRASpecialMealsComponent.prototype.INDRA_addToPreOrderMap = function (segment) {
        var _this = this;
        var pnr = this.bfmService.INDRA_getActiveBookedTrip().data.pnr;
        if (pnr && segment && segment.idInfoSegment) {
            this.ancillariesService.INDRA_retrieveFlightMealsAvailability(pnr, segment.idInfoSegment).subscribe(function (data) {
                if (data.status === '200') {
                    _this.passengers.forEach(function (pax) {
                        _this.INDRA_addLabelGroups(pax, data.meals.length - 1);
                        data.meals.forEach(function (meal) {
                            _this.optionList[_this.passengers.indexOf(pax)].unshift(_this.buildPreOrderMeal(meal, pax, segment));
                        });
                        _this.optionList[_this.passengers.indexOf(pax)].unshift(_this.preOrderMealsCollectionLabel);
                    });
                    if (_this.optionList[0][0] === _this.preOrderMealsCollectionLabel) {
                        _this.INDRA_setAddedMeals();
                    }
                }
                _this.isServiceLoading = false;
            });
        }
    };
    INDRASpecialMealsComponent.prototype.buildPreOrderMeal = function (meal, pax, segment) {
        return {
            'text': this.INDRA_getTranslation(TRANSLATION_ANCILLARY_DETAILED + meal.mealCode) + ' (0.00' + getCurrencySymbol(this.currencyService.INDRA_getCurrency(), 'wide') + ')',
            'value': {
                'code': meal.mealCode,
                'img': (meal && meal.image) ? this.domSanitizer.bypassSecurityTrustUrl('data:application/octet-stream;base64, ' + meal.image) : null,
                'currency': this.currencyService.INDRA_getCurrency(),
                'description': TRANSLATION_ANCILLARY_PREORDER + meal.mealCode + '.' + meal.mealDescription + '.description',
                'maxQuantity': 1,
                'price': 0.00,
                'itemId': 21,
                'flightCardId': this.flightCardId,
                'flightId': this.flight.idFlight,
                'paxId': this.passengers.indexOf(pax) + 1,
                'segmentId': segment.idInfoSegment,
                'paxTatto': pax.tatoo,
                'points': null,
                'enabled': true,
                'ssrTatto': null,
                'flightBasedAddOns': [],
                'payWithMiles': false,
                'type': ANCILLARY_PRODUCT_GROUP_CODE_MEAL,
                'subCode': 'PREORDER'
            }
        };
    };
    INDRASpecialMealsComponent.prototype.INDRA_addLabelGroups = function (pax, index) {
        if (this.optionList[this.passengers.indexOf(pax)] && !this.optionList[this.passengers.indexOf(pax)].includes(this.specialMealsCollectionLabel)) {
            this.optionList[this.passengers.indexOf(pax)].unshift(this.specialMealsCollectionLabel);
        }
    };
    return INDRASpecialMealsComponent;
}(INDRAExtraSidebar));
export { INDRASpecialMealsComponent };
